import standing from '../../assets/brand/corvin.svg';
import waving from '../../assets/brand/corvin-waving.svg';
import thinking from '../../assets/brand/corvin-thinking.svg';
import pointing from '../../assets/brand/corvin-pointing.svg';
import thumbsUp from '../../assets/brand/corvin-thumbs-up.svg';
import avatar from '../../assets/brand/corvin-avatar.svg';
import avatarBlink from '../../assets/brand/corvin-avatar-blink.svg';

const SRC = {
  standing, waving, thinking, pointing, 'thumbs-up': thumbsUp, avatar, 'avatar-blink': avatarBlink,
};

// Corvin, CROW's in-app crow. Decorative by default (alt=""): the text next
// to him says what matters. Generated from brand/ -- see brand/sync.mjs and
// brand/README.md for which pose means what.
export default function CorvinArt({ pose = 'standing', size = 96, alt = '', className = '' }) {
  return (
    <img
      src={SRC[pose] || SRC.standing}
      alt={alt}
      height={size}
      draggable="false"
      className={`block w-auto select-none ${className}`}
      style={{ height: size }}
    />
  );
}
